import React, { useEffect, useState } from 'react';
import { SectionRenderer } from '../components/website/SectionRenderer';
import { applyDesignTokens } from '../hooks/useSiteConfig';

// Rendered inside the page builder's iframe; receives draft sections via postMessage for a true responsive preview.
export default function BuilderPreviewPage() {
  const [state, setState] = useState({ sections: [], selectedId: null });

  useEffect(() => {
    const onMsg = (e) => {
      if (e.data?.type === 'cms-preview') setState({ sections: e.data.sections || [], selectedId: e.data.selectedId || null });
      if (e.data?.type === 'cms-design') applyDesignTokens(e.data.design);
    };
    window.addEventListener('message', onMsg);
    window.parent?.postMessage({ type: 'cms-preview-ready' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  useEffect(() => {
    if (!state.selectedId) return;
    document.querySelector(`[data-section-id="${state.selectedId}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [state.selectedId]);

  return (
    <div className="min-h-screen bg-white cms-root" data-testid="builder-preview-frame">
      {state.sections.length === 0 ? <div className="p-20 text-center text-neutral-400">Add sections to see your page here.</div>
        : <SectionRenderer sections={state.sections} editor selectedId={state.selectedId} onSelect={(id) => window.parent?.postMessage({ type: 'cms-select', id }, '*')} />}
    </div>
  );
}
